import { render, staticRenderFns } from "./CourseRequests.vue?vue&type=template&id=216adb8e&scoped=true"
import script from "./CourseRequests.vue?vue&type=script&lang=js"
export * from "./CourseRequests.vue?vue&type=script&lang=js"
import style0 from "./CourseRequests.vue?vue&type=style&index=0&id=216adb8e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216adb8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('216adb8e')) {
      api.createRecord('216adb8e', component.options)
    } else {
      api.reload('216adb8e', component.options)
    }
    module.hot.accept("./CourseRequests.vue?vue&type=template&id=216adb8e&scoped=true", function () {
      api.rerender('216adb8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CourseRequests.vue"
export default component.exports